export default "__VITE_ASSET__61fb1688__"